import { type SortDirection, Table, Text } from '@factorialco/deprecated-design-system'

import InformationTooltip from 'modules/core/components/Inputs/InformationTooltip'
import i18n from 'modules/core/lib/i18n'

interface Props {
  sortAttribute: string
  sortDirection: SortDirection
  onSort: (attribute: string, sortDirection: SortDirection) => void
  canEmployeeSeeAggregatedPersonalInfo: boolean
  hasTeamsInsightsFeature: boolean
  hasClockInLocationEnabled: boolean
}

const Header = ({
  sortAttribute,
  sortDirection,
  onSort,
  canEmployeeSeeAggregatedPersonalInfo,
  hasTeamsInsightsFeature,
  hasClockInLocationEnabled,
}: Props) => {
  return (
    <Table.Head>
      <Table.Row>
        <Table.SortableHeadCell
          colSpan={3}
          attribute="name"
          onSort={onSort}
          sortAttribute={sortAttribute}
          sortDirection={sortDirection}
        >
          {i18n.t('teams.name')}
        </Table.SortableHeadCell>
        <Table.HeadCell colSpan={1}>{i18n.t('employees.common.team_members')}</Table.HeadCell>
        {hasTeamsInsightsFeature && (
          <>
            <Table.HeadCell colSpan={2}>{i18n.t('employees.common.averages')}</Table.HeadCell>
          </>
        )}
        {hasClockInLocationEnabled && (
          <Table.HeadCell colSpan={2}>
            <InformationTooltip
              information={i18n.t('teams.working_location_tooltip')}
              icon="alert"
            />
            <Text.Normal weight="semibold" size="200" color="grey800">
              {i18n.t('teams.working_location')}
            </Text.Normal>
          </Table.HeadCell>
        )}
        {canEmployeeSeeAggregatedPersonalInfo && (
          <Table.HeadCell colSpan={2}>
            <Text.Normal weight="medium" size="200" color="grey800">
              {i18n.t('employees.common.gender_distribution')}
            </Text.Normal>
          </Table.HeadCell>
        )}
        <Table.HeadCell colSpan={1} />
      </Table.Row>
    </Table.Head>
  )
}

export default Header
